import React from "react";
import { useTranslation } from "react-i18next";
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { SxProps } from "@mui/system";
import { useModal } from "../../shared/technical/hooks/useModal";
import { KeycloakUsersImportDialog } from "./KeycloakUsersImportDialog";
import { CSVFileUsersImportDialog } from "./CSVFileUsersImportDialog";
import { Download } from "@mui/icons-material";
import { useAxios } from "../../shared/technical/rest/AxiosProvider";
import { exportUsersCsv } from "./UsersApi";
import { toUrlParams } from "../../shared/technical/rest/restApi";
import { fullPageable } from "../../shared/technical/rest/pageable";
import { SpecialMenu } from "../../shared/components/menu/SpecialMenu";

export function UsersMoreMenu(props: {
  userCount: number,
  entityQueryParams?: string,
  sx?: SxProps,
}) {
  const { userCount, entityQueryParams, sx } = props;
  const { t } = useTranslation();
  const axios = useAxios();
  const {show: showKcDialog, visible: kcDialogVisible, close: closeKcDialog} = useModal();
  const {show: showCsvDialog, visible: csvDialogVisible, close: closeCsvDialog} = useModal();

  const handleExport = () => {
    exportUsersCsv(axios, entityQueryParams + "&" + toUrlParams(fullPageable()))
      .catch((e) => console.error("Export users failed", e))
  };

  const handleKeycloak = () => {
    showKcDialog();
  };

  const handleCsv = () => {
    showCsvDialog();
  };

  return (
    <Box sx={sx}>
      <SpecialMenu>
        <MenuItem onClick={handleExport}>
          <ListItemIcon>
            <Download />
          </ListItemIcon>
          <ListItemText primary={`${t('buttons.export')} (${userCount})`} />
        </MenuItem>
        <MenuItem onClick={handleKeycloak}>
          <ListItemText primary={t('KeycloakUsersImport.title')} />
        </MenuItem>
        <MenuItem onClick={handleCsv}>
          <ListItemText primary={t('CSVUsersImport.title')} />
        </MenuItem>
      </SpecialMenu>
      <KeycloakUsersImportDialog open={kcDialogVisible} handleClose={closeKcDialog} />
      <CSVFileUsersImportDialog open={csvDialogVisible} handleClose={closeCsvDialog} />
    </Box>
  );
}
